import './App.css';
import './Work.css';
import './Animations.css';

import React, {useState, useEffect} from 'react';
import { useLocation, useNavigate } from 'react-router-dom'
import useImagePreloader from './useImagePreloader'

import transition from './transition.js';

import NavBar from './NavBar';
import ProjectThumb from './ProjectThumb';
import ProjectThumbRedirect from './ProjectThumbRedirect';
import Footer from './Footer';

import Thumb_Clock from './img/project/clock/thumb.jpg';
import Thumb_Footwork from './img/project/footwork/thumbspin.gif';
import Thumb_Squish from './img/project/squish/thumb.jpg'
import Thumb_Forting from './img/project/forting/thumb.jpg'
import Thumb_InfiniteMerch from './img/project/infinite-merch/thumb.jpg'
import Thumb_Mitgala from './img/project/mitgala/thumb.jpg'
import Thumb_TangibleSampling from './img/project/tangible-sampling/thumb.jpg'
import Thumb_Chair from './img/project/chair/thumb.jpg'
import Thumb_Beatfarm from './img/project/beatfarm/thumb.jpg'
import Thumb_21m080 from './img/project/21m080/thumb.jpg'
import Thumb_Mask from './img/project/mask/thumb.jpg'
import Thumb_Hardcell from './img/project/hardcell/thumb.jpg'
import Thumb_IMS from './img/project/ims/thumb.jpg'
import Thumb_AI from './img/project/ai/thumb.gif'
import Thumb_TacticalType from './img/project/tactical-type/thumb.gif'
import Thumb_HonestType from './img/project/honest-type/thumb.jpg'
import Thumb_AdobeHome from './img/project/adobe-home/thumb.jpg'
import Thumb_BirthCertificate from './img/project/birth-certificate/thumb.jpg'
import Thumb_PecanSans from './img/project/pecan-sans/thumb.jpg'
import Thumb_Drift from './img/project/drift/thumb.jpg'
import Thumb_Futbot from './img/project/futbot/thumb.jpg'
import Thumb_Pendulum from './img/project/pendulum/thumb.jpg'
import Thumb_Infinite from './img/project/infinite/thumb.jpg'
import Thumb_Light from './img/project/light/thumb.jpg'
import Thumb_Pedals from './img/project/pedals/thumb.jpg'
import Thumb_Models from './img/project/models/thumb.jpg'
import Thumb_Posters from './img/project/posters/thumb.jpg'
import Thumb_DAD from './img/project/dad/thumb.jpg'
import Thumb_B2Web from './img/project/b2web/thumb.jpg'
import Thumb_HTMAA from './img/project/htmaa/thumb.gif'
import Thumb_Golf from './img/project/golf/thumb.png'
import Thumb_SplashCourse from './img/project/splash-course/thumb.jpg'
import Thumb_RejisRave from './img/project/rejisrave/thumb.jpg'
import Thumb_Radarco from './img/project/radarco/thumb.jpg'
// import Thumb_NEWPROJ from './img/project/NEWPROJ/thumb.jpg'

const preloadSrcList = [
    Thumb_Radarco,
    Thumb_Clock,
    Thumb_Footwork,
    Thumb_Squish,
    Thumb_Forting,
    Thumb_InfiniteMerch,
    Thumb_Mitgala,
    Thumb_TangibleSampling,
    Thumb_Chair,
    Thumb_Beatfarm,
    Thumb_21m080,
    Thumb_Mitgala,
    Thumb_Mask,
    Thumb_Hardcell,
    Thumb_IMS,
    Thumb_AI,
    Thumb_TacticalType,
    Thumb_HonestType,
    Thumb_AdobeHome,
    Thumb_BirthCertificate,
    Thumb_PecanSans,
    Thumb_Drift,
    Thumb_Futbot,
    Thumb_Pendulum,
    Thumb_Infinite,
    Thumb_Light,
    Thumb_Pedals,
    Thumb_Models,
    Thumb_Posters,
    Thumb_DAD,
    Thumb_B2Web,
    Thumb_HTMAA,
    Thumb_Golf,
    Thumb_SplashCourse,
    Thumb_RejisRave,
    // Thumb_NEWPROJ,
]

const thumbDataDict = {
    // "defaultName": [ Thumb_DefaultImg, "Thumb Title", "Thumb Subtitle" , redirect to other site?],
    "radarco": [ Thumb_Radarco, "The Radar Co.", "Built frontend for radar monitoring webapp", false],
    "clock": [ Thumb_Clock, "Sequencer Clock", "An instrument that lets you play with time" , false],

    "squish": [ Thumb_Squish, "Squish", "A squishable & modular music interface", false],
    
    "forting": [ Thumb_Forting, "Forting", "A kit for pillow forting outdoors", false],
    "ai": [ Thumb_AI, "AI Experiments", "", false],
    "b2web": [ Thumb_B2Web, "Burton 2 Website", "", false],
    "beatfarm": [ Thumb_Beatfarm, "Beatfarm", "Hip-hop beat-making game", false],
    "birth-certificate": [ Thumb_BirthCertificate, "My Birth Certificate??", "kinda", "https://diegoyl.github.io/newspaper-birth-certificate/"],
    "tactical-type": [ Thumb_TacticalType, "Tactical Type", "A typeface made from a socccer game", "https://diegoyl.github.io/tactical-type/"],
    "htmaa": [ Thumb_HTMAA, "How To Make (Almost) Anything", "", "https://fab.cba.mit.edu/classes/863.22/Architecture/people/Diego/"],
    
    "chair": [ Thumb_Chair, "Pair Chair", "Re-assembleable chair made of two identical parts", false],
    "dad": [ Thumb_DAD, "D.A.D.", "A band I am a part of!", false],
    "drift": [ Thumb_Drift, "Drift", "Intentional error in machine-aided drawings", false],
    "footwork":[ Thumb_Footwork, "Footwork XVII", "Branding & T-Shirt Design" , false],
    "21m080": [ Thumb_21m080, "Digital Synth Interface", "Making music with live-coding", false],
    "adobe-home": [ Thumb_AdobeHome, "Adobe Home", "", false],
    "infinite-merch": [ Thumb_InfiniteMerch, "Infinite Merch", "Hand-printed T-Shirts, stickers, and totes for Infinite Magazine", false],
    "mitgala": [ Thumb_Mitgala, "MIT Gala", "Branding for Infinite's innaugural fashion show", false],
    "infinite": [ Thumb_Infinite, "Infinite Magazine", "I was the Visual Design Director for MIT's fashion magazine", false],
    "tangible-sampling": [ Thumb_TangibleSampling, "Tangible Sampling", "Collaborative music-making installation", false],

    "hardcell": [ Thumb_Hardcell, "HARDCELL®", "", false],
    "futbot": [ Thumb_Futbot, "Futbot", "Robot for 2.007 competition ", false],
    
    "golf": [ Thumb_Golf, "Golf", " [🚧Under Construction]", "https://diegoyl.github.io/golf/"],
    "rejisrave": [ Thumb_RejisRave, "Reji's Rave", "A game about a crab who loves to dance", false],
    // "NEWPROJ": [ Thumb_NEWPROJ, "NEWPROJ", "", false],

    // "ims": [ Thumb_IMS, "Interactive Music Systems", "subtitle", false],
    
    "honest-type": [ Thumb_HonestType, "Honest Type", "Exploring our trust in the words of the digital world", false],
    "pecan-sans": [ Thumb_PecanSans, "Pecan Sans", "An alphabet made from pecans", false],
    "splash-course": [ Thumb_SplashCourse, "Splash Course", "Prototype for an ed-tech website", "https://github.com/diegoyl/splash-course/blob/main/README.md"],
    
    // "posters": [ Thumb_Posters, "Posters", "subtitle", false],

    // "mask": [ Thumb_Mask, "Mask", "subtitle", false],
    // "pendulum": [ Thumb_Pendulum, "Pendulum Sculptures", "subtitle", false],
    // "light": [ Thumb_Light, "Wax Lamp", "subtitle", false],
    // "pedals": [ Thumb_Pedals, "Guitar Pedals", "subtitle", false],
    // "models": [ Thumb_Models, "Miniatures", "subtitle", false],
}

const tagProjects = {
    "all": [
        // "radarco",
        "squish",
        "clock",
        "forting", // TODO: add forting process
        "beatfarm",
        "footwork",
        "tangible-sampling", 
        "rejisrave",
        "21m080",
        "infinite-merch",
        "mitgala",
        "tactical-type",
        "htmaa",
        "ai",
        "infinite", //  TODO: infinite unfinished
        "hardcell",
        "chair",
        // "splash-course",
        "birth-certificate",
        "honest-type",
        "golf",
        "pecan-sans",
        "drift",
        "adobe-home",
        "futbot",
        // "b2web",
        "dad",
        // "NEWPROJ",
    ],
    
    
    "Web Dev": [
        // "radarco",
        "beatfarm",
        // "splash-course",
        "rejisrave",
        "21m080",
        "tactical-type",
        // "b2web",
        "birth-certificate",
    ],
    "Product Design": [
        "squish",
        "clock",
        "forting",
    ],
    "Graphic Design": [
        "footwork",
        "mitgala",
        "infinite",
        "infinite-merch",
        "tactical-type",
        "honest-type",
        "ai",
        "birth-certificate",
        "pecan-sans",
        "drift",
    ],
    "Physical": [
        "clock",
        "squish",
        "tangible-sampling", 
        "forting",
        "chair",
        "hardcell",
        "htmaa",
        "futbot",
    ],
    "Game Dev": [
        "rejisrave",
        "beatfarm",
        "golf",
    ]
}  

function initialWorkGridType() {
    if (typeof window === 'undefined') return 'grid2';
    return window.matchMedia('(max-width: 768px)').matches ? 'grid1' : 'grid2';
}

  
function Work() {




    var [erasing, setErasing] = useState(false)
    function redirectDelay(path) {
      setErasing(true)
      setTimeout(() => {
        window.location.href = path;
      }, 310)
    }
    var [selectedCategory, setSelectedCategory] = useState("all")
    var [gridType, setGridType] = useState(initialWorkGridType)
    var [showToTop, setShowToTop] = useState(false)
    var categoriesList = Object.keys(tagProjects)
    
    // Filtering logic
    function getProjectsToShow() {
        if (!selectedCategory || selectedCategory === "all") return tagProjects["all"];
        return tagProjects[selectedCategory] ?? tagProjects["all"];
    }
    
    function selectCategory(categoryName) {
        setSelectedCategory(prev => (prev === categoryName ? "all" : categoryName));
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY
            const windowHeight = window.innerHeight
            setShowToTop(scrollY > windowHeight)
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])
    
    const location = useLocation();
    const navigate = useNavigate();
    var categoryPassedIn = false;
    useEffect(() => {
        document.title = "Work"
        
        // // var searchData = location.search + "";
        // // if (searchData) {
        // //     categoryPassedIn = searchData.split("=")[1];
        // //     console.log("SD: ",searchData)
        // //     if (categoryPassedIn="coding"){
        // //         categoryPassedIn = "ux/coding"
        // //     }
        // //     setCategory(categoryPassedIn)
        // //     navigate('/projects', { replace: true });
        // // } else {
        // //     setCategory("all")
        // // }

        // // var searchData = location.search + "";
        // // console.log("SD1: ",window.location.hash.replace("#", "")) 
        // // var pathname = location.pathname
        // var pathnameCategory = location.pathname.split("-")[1]
        // console.log("pathnameCat: ", pathnameCategory)

        // if (pathnameCategory) {
        //     categoryPassedIn = pathnameCategory;
        //     console.log("split(-)[1]: ", categoryPassedIn)
            
        //     if (categoryPassedIn=="coding") {
        //         categoryPassedIn = "ux/coding"
        //     }

        //     setCategory(categoryPassedIn)

        //     navigate('/projects', { replace: true });
        // } else {
        //     setCategory("all")
        // }
        // console.log("defCat_= ",category)



    // const { imagesPreloaded } = useImagePreloader(preloadSrcList)

        // if (!imagesPreloaded) {
        //     console.log("Pre-Loading Images")
        //     checkPreload()
        // } else {
        //     setErasing(false)
        //     console.log("*** Images Loaded at 0 !")
        // }
    
    },[])

    // function checkPreload() {
    //     if (imagesPreloaded) {
    //         console.log("*** Images Loaded !")
    //         setErasing(false)
    //     } else {
    //         setTimeout(()=> {
    //             checkPreload()
    //         },200)
    //     }

    // }
    


    function changeGridType(gt)  {
        window.scrollTo({top: 0, behavior: 'smooth'});
        if (gt!=gridType) {
            const projectGrid = document.getElementById('projectGrid')
            projectGrid.classList.add('gridFade'); // start animation            
            
            setTimeout(() => {
                setGridType(gt)
                projectGrid.classList.remove('gridFade'); // reset animation
            },700)
        }
    }


  function toCategoriesTop() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }


  return (
    <div style={{width:"100%"}}>
             <NavBar page={"work"}></NavBar>
      <div id="erase-container" className={erasing ? "beginErase transition-container":"transition-container"}>
            {/* <p>...</p> */}
      </div>

        <div id="projects" className="content-padding splitGrid projectsMarginTop">

            <div className='splitDiv leftSplit'>
                <div id="projects-menu-fixed">
                    
                    <div id="projects-menu-inner">

                        <div className="tagsContainer">
                            <span className="categoriesTitleMobile">CATEGORIES</span>
                        </div>

                        <div className="tagsWrapper">
                            {["all", ...categoriesList.filter(tag => tag !== "all")].map(function(tagName,index) {
                                const isSelected = selectedCategory === tagName;
                                return (
                                    <button 
                                        key={index} 
                                        className={`categoryButton ${isSelected ? 'categoryButtonActive' : 'categoryButtonInactive'}`}
                                        onClick={() => selectCategory(tagName)}
                                    >
                                        <span className="categoryButtonText">{tagName.toUpperCase()}</span>
                                    </button>
                                )
                            })}
                        </div>
                        

                        <div id="gridBtnContainer">
                            <button id="gridBtn1" className={gridType==="grid1" ? "gridBtnActive gridButton":"gridButton"} onClick={() => changeGridType("grid1")}></button>
                            <button id="gridBtn2" className={gridType==="grid2" ? "gridBtnActive gridButton":"gridButton"} onClick={() => changeGridType("grid2")}></button>
                            <button id="gridBtn3" className={gridType==="grid3" ? "gridBtnActive gridButton":"gridButton"} onClick={() => changeGridType("grid3")}></button>
                        </div>


                        {/* TODO LINK THIS */}
                        {/* <p className="inactiveCategory" id="archiveLink" onClick={() => changeCategory("archive")}>ARCHIVE</p> */}
                    
                    </div>
      
                </div>

            </div>

            {/* TODO: CHANGE 1 COL GRID TO RECTANGLE IMAGES */}
            <div className='splitDiv rightSplit content-left'>
                <div id="projectGrid" className={gridType}>

                                                                                         {(() => {
                        const projectsToShow = getProjectsToShow();
                        return (
                        <>
                        {projectsToShow.map(function(projName,index) {

                            if (thumbDataDict[projName][3]) {
                                return (
                                    <div className="thumbLinkContainer" key={projName}>
                                            
                                        <ProjectThumbRedirect 
                                            thumbSrc={thumbDataDict[projName][0]}
                                            title={thumbDataDict[projName][1]}
                                            subtitle={thumbDataDict[projName][2]}
                                            redirect={thumbDataDict[projName][3]}

                                        ></ProjectThumbRedirect>  

                                    </div>
                                )
                            } else {

                                return (
                                    <div onClick={() => {redirectDelay("/" + projName)}} className="thumbLinkContainer" key={projName}>
                                            
                                        <ProjectThumb 
                                            thumbSrc={thumbDataDict[projName][0]}
                                            title={thumbDataDict[projName][1]}
                                            subtitle={thumbDataDict[projName][2]}
                                        ></ProjectThumb>  

                                    </div>
                                )
                            }

                        })}
                        </>
                        );
                    })()}
                </div>
            </div>
        </div>

        <div id="toCategoriesDiv">
            <p onClick={() => toCategoriesTop()} >⌃<br></br>CATEGORIES</p>
        </div>

        {/* Mobile To Top Button */}
        {showToTop && (
            <button 
                className="mobileToTopButton"
                onClick={scrollToTop}
                aria-label="Scroll to top"
            >
                ↑
            </button>
        )}

        <Footer></Footer>

    </div>
  );
}

export default transition(Work);
